module.exports = __webpack_public_path__ + "img/20.147cc98f.webp";